import React from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle } from 'lucide-react';

const ClaimConfirmationModal = ({ show, onClose, onConfirm }) => {
    if (!show) return null;

    return createPortal(
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 }}>
            <div className="bg-white rounded-4 shadow-lg p-4 mx-3" style={{ width: '420px', maxWidth: '100%' }}>
                <div className="text-center">
                    {/* Icon */}
                    <div className="d-inline-flex align-items-center justify-content-center bg-warning bg-opacity-10 text-warning rounded-circle mb-3" style={{ width: '60px', height: '60px' }}>
                        <AlertTriangle size={30} strokeWidth={2} />
                    </div>

                    {/* Heading */}
                    <h4 className="fw-bold mb-2 text-dark">Confirm Claim Finalization!</h4>

                    {/* Body Text */}
                    <p className="text-secondary mb-4" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
                        Generating the Claim ID will finalize this claim.<br />
                        No further edits will be allowed.
                    </p>

                    {/* Action Buttons */}
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-light flex-fill py-2"
                            onClick={onClose}
                            style={{ fontWeight: '600', color: '#555' }}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn flex-fill py-2 text-white"
                            onClick={onConfirm}
                            style={{
                                fontWeight: '600',
                                backgroundColor: '#006BB3',
                                border: 'none'
                            }}
                        >
                            Proceed
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ClaimConfirmationModal;
